import script from "./bonusomat-spin-buttons.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusomat-spin-buttons.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__